import axios from "axios"
axios.defaults.withCredentials = true

export const signup = async (user) =>
  await axios.post(process.env.REACT_APP_SERVER_URI + "/api/signup", user)

export const addGender = async (data, token) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + "/api/attachGoogleReferral",
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        withCredentials: true,
      },
    },
  );

export const checkGender = async (userId) =>
  await axios.post(process.env.REACT_APP_SERVER_URI + "/api/validateAvatar", { userId })

export const checkRegistered = async (email) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + "/api/checkRegistered",
    email
  )

export const checkOTP = async (otpData) =>
  await axios.post(process.env.REACT_APP_SERVER_URI + "/api/checkOTP", otpData)

export const signin = async (user) =>
  await axios.post(process.env.REACT_APP_SERVER_URI + "/api/signin", user, {
    withCredentials: true,
  })

export const getUserProfile = async (token, platform = "web") =>
  await axios.get(process.env.REACT_APP_SERVER_URI + "/api/user/profile", {
    headers: {
      Authorization: `Bearer ${token}`,
      "x-platform": platform,
      withCredentials: true,
    },
  })

export const updateUserProfile = async (token, data) =>
  await axios.patch(process.env.REACT_APP_SERVER_URI + "/api/user/profile", data, {
    headers: {
      Authorization: `Bearer ${token}`,
      withCredentials: true,
    },
  });

export const updatePassword = async (data) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + "/api/updatePassword",
    data,
    {
      withCredentials: true,
    }
  )

export const checkForgotOTP = async (otp) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + "/api/checkForgotOTP",
    otp,
    {
      withCredentials: true,
    }
  )

export const sendForgotOTP = async (email) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + "/api/forgotPassword",
    email,
    {
      withCredentials: true,
    }
  )

export const refreshToken = async (platform = "web") =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + "/api/refreshToken",
    {},
    {
      withCredentials: true,
      headers: {
        "x-platform": platform,
      }
    }
  )

export const logout = async (token) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + "/api/logout",
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
        withCredentials: true,
      },
    }
  )

export const checkEmail = async (email) =>
  await axios.post(process.env.REACT_APP_SERVER_URI + "/api/checkemail", email)

export const corporateSignUp = async (data) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + "/api/corporate/signup",
    data
  )

export const sendOTP = async (data) =>
  await axios.post(process.env.REACT_APP_SERVER_URI + "/api/sendOTP", data)

export const checkTeamLocation = (token) => {
  return axios.get(
    process.env.REACT_APP_SERVER_URI + "/api/checkTeamLocation",
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
}

export const getTeamLocation = (data, token) => {
  return axios.post(
    process.env.REACT_APP_SERVER_URI + "/api/clients/teams", data , 
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
}

export const updateTeamLocation = (data, token) => {
  return axios.patch(
    process.env.REACT_APP_SERVER_URI + "/api/updateTeamLocation",
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
}

export const sendOTPToUser = async (data) =>
  await axios.post(process.env.REACT_APP_SERVER_URI + "/api/sendMobileOtp", data)

export const signinB2C = async (data) =>
  await axios.post(process.env.REACT_APP_SERVER_URI + "/api/signinB2C", data, {
    withCredentials: true,
  })

export const signinB2B = async (data) =>
  await axios.post(process.env.REACT_APP_SERVER_URI + "/api/signinB2B", data, {
    withCredentials: true,
  })

export const sendForgotOTPToUser = async (data) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + "/api/sendOTP?mobile=true",
    data,
    {
      withCredentials: true,
    }
  )

export const updateB2BPassword = async (otpData) =>
  await axios.post(process.env.REACT_APP_SERVER_URI + "/api/updatePassword?mobile=true", otpData)

export const signUpB2C = async (data) =>
  await axios.post(process.env.REACT_APP_SERVER_URI + "/api/signupB2C", data)

export const updateProfileB2B = async (data, token) =>
  await axios.patch(process.env.REACT_APP_SERVER_URI + "/api/user/b2b/profile", data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
export const signUpB2B = async (data) =>
  await axios.post(process.env.REACT_APP_SERVER_URI + "/api/signupB2B", data)

export const getOnBoardingQuestions = async (userId, token) =>
  await axios.get(process.env.REACT_APP_SERVER_URI + `/api/user/${userId}/questions`, {
    headers: {
      Authorization: `Bearer ${token}`,
      withCredentials: true,
    }
  })

export const giveOnboardingQuestionAnswers = async (userId, token, payload) =>
  await axios.post(process.env.REACT_APP_SERVER_URI + `/api/user/${userId}/answers`, {answers: payload},{
    headers: {
      Authorization: `Bearer ${token}`,
      withCredentials: true,
    }
  })

export const getGoogleClientTeamLocation = (token) => {
    return axios.get(
      process.env.REACT_APP_SERVER_URI + "/api/teamLocation", 
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
}

export const getUserAvatars = (token) => {
  return axios.get(
    process.env.REACT_APP_SERVER_URI + "/api/avatars", 
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
  )
}
